/*
  Smooth-scroll handlers for the small links under the product title:
  - reviews: jumps to the Judge.me review widget further down the page
  - faq: expands the clamped description and jumps to its FAQ heading

  Both links keep a real href, so without JS they still land near the target.
*/
if (!window.productQuickLinksBound) {
  window.productQuickLinksBound = true;

  const FAQ_PATTERN = /\bfaqs?\b|frequently asked/i;

  // Prefer a real heading; fall back to bold text or a short paragraph, since
  // descriptions pasted from docs often mark headings up as <p><strong>.
  const findFaqHeading = (container) => {
    const selectors = ['h1, h2, h3, h4, h5, h6', 'strong, b', 'p'];
    for (const selector of selectors) {
      const match = Array.from(container.querySelectorAll(selector)).find(
        (el) => el.textContent.length < 80 && FAQ_PATTERN.test(el.textContent)
      );
      if (match) return match;
    }
    return null;
  };

  const scrollToFaq = (link) => {
    const content = document.querySelector(link.getAttribute('href'));
    if (!content) return false;

    const wrapper = content.closest('collapsible-description');
    if (wrapper && typeof wrapper.setExpanded === 'function' && !wrapper.classList.contains('is-not-collapsible')) {
      wrapper.setExpanded(true);
    }

    const target = findFaqHeading(content) || content;
    // Wait a frame so the expanded height is laid out before measuring.
    requestAnimationFrame(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    return true;
  };

  const scrollToReviews = () => {
    const target =
      document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
    if (!target) return false;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-quick-link]');
    if (!link) return;

    const handled = link.dataset.quickLink === 'faq' ? scrollToFaq(link) : scrollToReviews();
    if (handled) event.preventDefault();
  });
}
